import setRenderStatus from './set-render-status';

export default {
  setRenderStatus,
};
